<div mat-dialog-title>
    <div class="close hidden-xs" (click)="close()">&#10005;</div>

    <div style="width: 100%; display: flex; flex-direction: column; gap: 8px">
        <div class="heading-text">
            @if (data.heading_text) {
                <img src="/assets/images/address-location.svg" class="address-location" />
            }
            <span>{{ data.heading_text }}</span>
        </div>

        <span class="formatted-address">
            @if (!data.heading_text) {
                <img src="/assets/images/address-location.svg" class="address-location" />
            }
            {{ address_locality }}
        </span>
    </div>
</div>

<div mat-dialog-content class="form-fields-theme">
    <form [formGroup]="addressForm">
        <div class="address-form-wrapper">
            @for (field of addressFields; track field; let idx = $index) {
                <div>
                    <label class="field-heading">
                        {{ field.heading_text }}
                    </label>
                    <mat-form-field appearance="outline">
                        <input matInput [id]="'' + idx" [formControlName]="'' + idx" [placeholder]="field.placeholder_text" />
                        @if (addressForm.get('' + idx).hasError('required')) {
                            <mat-error> This field is required. </mat-error>
                        }
                        @if (addressForm.get('' + idx).hasError('noDoublePipe')) {
                            <mat-error> Address Field cannot contain double pipes (||). </mat-error>
                        }
                    </mat-form-field>
                </div>
            }
        </div>

        <div class="tag-address-wrapper">
            <div>
                <span class="description"> TAG THIS ADDRESS </span>

                <div class="tag-address">
                    @for (option of addressOptions; track option) {
                        <button
                            (click)="!option.disabled && setAddressType(option.value)"
                            class="address-type center"
                            [class.disabled]="option.disabled"
                            [class.selected]="option.value == addressType">
                            <mat-icon aria-hidden="true" class="option-icon">
                                {{ option.icon }}
                            </mat-icon>
                            {{ option.label }}
                        </button>
                    }
                </div>
            </div>

            @if (addressType === 2) {
                <div style="width: 100%">
                    <span class="custom-name"> CUSTOM NAME </span><br />
                    <mat-form-field>
                        <input [id]="'customName'" matInput placeholder="Eg: Ganesh’s Place" [formControlName]="'customName'" />
                        @if (addressForm.get('customName').hasError('required')) {
                            <mat-error> This field is required. </mat-error>
                        }
                        @if (addressForm.get('customName').hasError('noDoublePipe')) {
                            <mat-error> Address Field cannot contain double pipes (||). </mat-error>
                        }
                    </mat-form-field>
                </div>
            }
        </div>
    </form>
</div>
<div class="sticky-button">
    <button class="save-and-proceed" btn-primary size="full" (click)="add(addressForm)" [isLoading]="addingAddress">
        Save & Proceed
    </button>
</div>
